/**
 * Shared checkbox row chrome classes for BooleanField (`chrome` prop).
 */
export const CHECKBOX_BUTTON_CLASS =
	"flex items-center gap-2.5 rounded-md border bg-muted/30 px-3 py-2.5 text-xs";

/** Waitlist-style bordered control row (h-9). */
export const CHECKBOX_BORDERED_ROW_CLASS =
	"flex h-9 w-full cursor-pointer items-center gap-3 rounded-md border border-input bg-card px-3 text-sm shadow-xs transition-colors focus-within:outline-hidden focus-within:border-ring focus-within:ring-1 focus-within:ring-ring";

/** Minimal flex gap row (default checkbox chrome). */
export const CHECKBOX_PLAIN_CLASS =
	"flex w-full cursor-pointer items-center gap-3";
